import React, { useContext, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { Grid, Menu } from '@material-ui/core';
import AuthContext from '../AppAuthContext';
import { MyWhiteButton, MyMenuItem } from '../../styling/Styles';
import BuildUpsExitPopUpWindow from '../BuildApps/PopUpsValidations/BuildUpsExitPopUpWindow';
import BuildAppsExitPopUpCannotSave from '../BuildAppsExitPopUpCannotSave';
import DisplayNumberMessages from './Messages/DisplayNumberMessages';
import MessageDialog from './Messages/MessageDialog';
import { nameExists, nameNull } from '../../validations/validations';
import LogoutPopUp from './PopUps/LogoutPopUp';

const WabliAppBar = (props) => {
  const {
    isBuildApp,
    savedPagesPerProject,
    projectNamesPages,
    savedPageClicked,
    selectedPage,
    selectedProject,
    updateData,
    setUpdateData
  } = props;
  const { state, dispatch } = useContext(AuthContext);
  const [alertExitBuildUps, setAlertExitBuildUps] = React.useState(false);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [aboutToLogout, setAboutToLogout] = React.useState(false);
  const [alertExitBuildAppsCannotSave, setAlertExitBuildAppsCannotSave] = React.useState(false);
  const navigate = useNavigate();
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [openAlertLogOut, setOpenAlertLogout] = React.useState(false);

  
  const needSave = () => {
    let need = false;

    if (savedPagesPerProject !== undefined) {
      savedPagesPerProject.forEach((element, index) => {
        if (selectedProject === index) {
          savedPagesPerProject[index].forEach((element2, index2) => {
            if (element2 === false && index2 === selectedPage) {
              need = true;
            }
          });
        }
      });
    }

    return need;
  };

  const changeToHome = () => {
    if (isBuildApp === true) {
      if (needSave() === true) {
        if (
          nameExists(selectedPage, selectedProject) === true ||
          nameNull(selectedPage, selectedProject) === true
        ) {
          setAlertExitBuildAppsCannotSave(true);
        } else {
          setAlertExitBuildUps(true);
        }
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };

  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleLogout = () => {


    if (needSave() === true) {
      setAboutToLogout(true);

      if (
        nameExists(selectedPage, selectedProject) === true ||
        nameNull(selectedPage, selectedProject) === true
      ) {
        setAlertExitBuildAppsCannotSave(true);
      } else {
        setAlertExitBuildUps(true);
      }
    } else {
      dispatch({
        type: 'LOGOUT'
      });
    }
  };

  if (!state.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  const redirectToAbout = () => {
    navigate('/about_page');
  };

  const redirectToProfilePage = () => {
    navigate('/profile_page');
  };

  const openMessageDialogPopUp = () => {
    setOpenMessageDialog(true);
  };

  const openLogOutPopUp = () => {
    setOpenAlertLogout(true);
    setAnchorEl1(null);
  }

  return (
    <>
      <div className={clsx('appBarStyle')}>
        <div className={clsx('generalMarg')}>
          <Grid container>
            <Grid item xs={2}>
              <img
                id="wabliAppbarImage"
                src='/images/General/Wabli_white_logo.png'
                alt="logo"
                onClick={changeToHome}
                className={clsx('appBarLogoStyle', 'teamSelector')}
                aria-hidden="true"
              />
            </Grid>

            <Grid
              container
              item
              xs={10}
              alignItems="center"
              direction="row"
              justifyContent="flex-end"
            >
              <Grid item>
                <MyWhiteButton onClick={changeToHome}> Home </MyWhiteButton>
              </Grid>

              <BuildUpsExitPopUpWindow openAlert={openAlert} setOpenAlert={setOpenAlert} />
              <Grid item>
                <p className={clsx('obstacleAppBar')}> | </p>
              </Grid>
              {/* <Grid item>
                <MyWhiteButton onClick={redirectToAbout}> About </MyWhiteButton>
              </Grid>

              <Grid item>
                <p className={clsx('obstacleAppBar')}> | </p>
              </Grid> */}
              <Grid onClick={openMessageDialogPopUp} item className={clsx('teamSelector')}>
                <MyWhiteButton> Messages </MyWhiteButton>
                <DisplayNumberMessages updateData={updateData} />
              </Grid>
              <Grid item>
                <p className={clsx('obstacleAppBar')}> | </p>
              </Grid>
              <Grid item>
                <MyWhiteButton id="myProfileButton" onClick={handleClick1}>
                  My profile
                </MyWhiteButton>
                <Menu
                  id="simple-menu1"
                  elevation={0}
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                  }}
                  anchorEl={anchorEl1}
                  open={Boolean(anchorEl1)}
                  onClose={handleClose1}
                >
                  <MyMenuItem id="profileButton" onClick={redirectToProfilePage}>
                    Profile
                  </MyMenuItem>
                  <MyMenuItem id="logoutButton" onClick={openLogOutPopUp}>
                    Logout
                  </MyMenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
      <BuildUpsExitPopUpWindow
        openAlert={alertExitBuildUps}
        setOpenAlert={setAlertExitBuildUps}
        aboutToLogout={aboutToLogout}
        savedPageClicked={savedPageClicked}
      />
      <BuildAppsExitPopUpCannotSave
        openAlert={alertExitBuildAppsCannotSave}
        setOpenAlert={setAlertExitBuildAppsCannotSave}
        savedPagesPerProject={savedPagesPerProject}
        projectNamesPages={projectNamesPages}
        aboutToLogout={aboutToLogout}
      />
      <MessageDialog
        open={openMessageDialog}
        setOpen={setOpenMessageDialog}
        setUpdateData={setUpdateData}
        dispatch={dispatch}
      />
      <LogoutPopUp
        openAlert={openAlertLogOut}
        setOpenAlert={setOpenAlertLogout}
        handleLogout={handleLogout}
      />
      
    </>
  );
};

export default WabliAppBar;
